import { render, staticRenderFns } from "./TableStockoutChangesNewStock.vue?vue&type=template&id=7156c563&scoped=true&"
import script from "./TableStockoutChangesNewStock.vue?vue&type=script&lang=js&"
export * from "./TableStockoutChangesNewStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156c563",
  null
  
)

export default component.exports